import './CustomSubmit.css';
import { CustomModalContent } from '../index';
import { useDisclaimerContext } from '../../../lib/contexts';
import { useState, useEffect } from 'react';
import { handleEnterKey } from '../../../lib/utils';
import button from '../../../assets/img/button.png';

function CustomSubmit() {
  const { disclaimerContext } = useDisclaimerContext();
  const { partnerList, termsOfUse, privacyPolicy, arbitrate } =
    disclaimerContext;

  const [isOpen, setIsOpen] = useState({
    privacyPolicy: false,
    optOut: false,
    scrollToId: null,
  });

  const openModal = (key, scrollToId = null) => {
    setIsOpen({
      termsOfUse: false,
      privacyPolicy: false,
      partnerList: false,
      [key]: true,
      scrollToId,
    });
  };
  const closeModal = (key) => setIsOpen({ ...isOpen, [key]: false });

  const click = (event) => {
    if (event.target?.id === 'ppTag') {
      setIsOpen({
        privacyPolicy: true,
        termsOfUse: false,
      });
      event.preventDefault();
      event.stopPropagation();
    }
    if (event.target?.id === 'touTag') {
      setIsOpen({
        privacyPolicy: false,
        termsOfUse: true,
      });
      event.preventDefault();
      event.stopPropagation();
    }
  };

  useEffect(() => {
    handleEnterKey('.custom-submit__btn');
  }, []);

  return (
    <div className="custom-submit__container">
      <CustomModalContent
        title="Partner List"
        isOpen={isOpen.partnerList}
        onClose={() => closeModal('partnerList')}
        content={partnerList.data?.html}
        clickEvent={click}
        isHtml
      />
      <CustomModalContent
        title="Terms Of Use"
        isOpen={isOpen.termsOfUse}
        onClose={() => closeModal('termsOfUse')}
        content={termsOfUse.data?.html}
        clickEvent={click}
        isHtml
        scrollToId={isOpen.scrollToId}
      />
      <CustomModalContent
        title="Privacy Policy"
        isOpen={isOpen.privacyPolicy}
        onClose={() => closeModal('privacyPolicy')}
        content={privacyPolicy.data?.html}
        clickEvent={click}
        isHtml
      />
      <CustomModalContent
        title="Arbitrate"
        isOpen={isOpen.arbitrate}
        onClose={() => closeModal('arbitrate')}
        content={arbitrate.data?.html}
        clickEvent={click}
        isHtml
      />
      <div>
        <label className="tcpa-text">
          By clicking the button below, you acknowledge, consent, and agree to
          our terms at the bottom of this page.
        </label>{' '}
        <button type="submit" className="custom-submit__btn">
          Get your matches
        </button>{' '}
        <label className="tcpa-text">
          {
            'By clicking "GET YOUR MATCHES" you electronically sign (pursuant to the ESIGN Act) and agree: to share your information with up to '
          }
          <a
            className="custom-submit__button-as-link"
            href="#"
            onClick={(e) => {
              e.stopPropagation();
              openModal('partnerList');
            }}
          >
            3 Home Improvement Partners
          </a>
          ;
          {` that you are providing your prior express written consent for those `}
          <a
            className="custom-submit__button-as-link"
            href="#"
            onClick={(e) => {
              e.stopPropagation();
              openModal('partnerList');
            }}
          >
            partners
          </a>
          {` to contact you at the telephone number you provided (including through an automatic telephone dialing system, pre-recorded or artificial voice, AI, SMS and MMS) even if your telephone number is listed on any state, federal or corporate Do Not Call list; you agree to our `}
          <a
            href="#"
            className="custom-submit__button-as-link"
            onClick={(e) => {
              e.stopPropagation();
              openModal('termsOfUse');
            }}
          >
            Terms of Use
          </a>
          {', including its '}
          <a
            className="custom-submit__button-as-link"
            onClick={() => openModal('termsOfUse', 'arbitrate')}
          >
            Arbitration provision
          </a>
          {', and '}
          <a
            href="#"
            className="custom-submit__button-as-link"
            onClick={(e) => {
              e.stopPropagation();
              openModal('privacyPolicy');
            }}
          >
            Privacy Policy
          </a>
          ; and that we can use your data for marketing and analytics. Your
          consent, and e-signature, is not a condition of accessing our
          services, as you may email consent@rgrmarketing.com and you can revoke
          your consent at any time by emailing us.
        </label>
      </div>
      <label
        htmlFor="leadid_tcpa_disclosure"
        data-tf-element-role="consent-language"
        className="tcpa_disclosure"
      >
        <input type="hidden" id="leadid_tcpa_disclosure" />
        <label className="custom-submit__consent-text">
          By clicking the button below, you acknowledge, consent, and agree to
          our terms at the bottom of this page. By clicking &quot;GET YOUR
          MATCHES&quot; you electronically sign (pursuant to the ESIGN Act) and
          agree: to share your information with up to 3 Home Improvement
          Partners; that you are providing your prior express written consent
          for those partners to contact you at the telephone number you provided
          (including through an automatic telephone dialing system, pre-recorded
          or artificial voice, AI, SMS and MMS) even if your telephone number is
          listed on any state, federal or corporate Do Not Call list; you agree
          to our Terms of Use, including its Arbitration provision, and Privacy
          Policy; and that we can use your data for marketing and analytics.
          Your consent, and e-signature, is not a condition of accessing our
          services, as you may email consent@rgrmarketing.com and you can revoke
          your consent at any time by emailing us.
        </label>
      </label>
    </div>
  );
}

export default CustomSubmit;
